module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('div', {
    staticClass: "circleHeader"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.awards.title)
    }
  })]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.awards.content)
    }
  })]), _vm._v(" "), (_vm.awards.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url(" + _vm.awardsImage + ")")
    })
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f494690"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/Awards.vue
// module id = 776
// module chunks = 1